module.exports = __webpack_public_path__ + "img/setIcon2.10137027.png";